export const fontWeights = {
  regular: 400,
  bold: 700,
};
